import Session from '@/handler/session'
import Storage from '@/handler/storageLocal'
import serviceAPI from '@/components/containers/services'

const KEY_PREFIX = 'shortcuts_user_'
const PREFERENCE_KEY = 'shortcuts'

function getUserKey() {
  const auth = Session.getSession().auth
  const userId = auth && auth.user && auth.user.id ? auth.user.id : 'guest'
  return `${KEY_PREFIX}${userId}`
}

function readList() {
  const raw = Storage.getValue(getUserKey())
  if (!raw) return []
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

function writeList(list) {
  Storage.setValue(getUserKey(), JSON.stringify(list))
  syncToServer(list)
}

function syncToServer(list) {
  try {
    var value = JSON.stringify(list)
    serviceAPI.saveUserPreference(PREFERENCE_KEY, value).catch(function() {})
  } catch (e) {
    // silencioso: no bloquear la UI si falla
  }
}

const shortcuts = {
  all() {
    return readList()
  },
  has(fullPath) {
    return readList().some(item => item.fullPath === fullPath)
  },
  add(item) {
    const list = readList()
    if (list.some(entry => entry.fullPath === item.fullPath)) return list
    const next = list.concat([{
      title: item.title,
      fullPath: item.fullPath,
    }])
    writeList(next)
    return next
  },
  addDivider(title) {
    const list = readList()
    const id = 'divider_' + Date.now()
    const next = list.concat([{
      title: title || 'Grupo',
      type: 'divider',
      id: id,
    }])
    writeList(next)
    return next
  },
  removeByIndex(index) {
    const list = readList()
    if (index < 0 || index >= list.length) return list
    const next = list.slice()
    next.splice(index, 1)
    writeList(next)
    return next
  },
  renameByIndex(index, title) {
    const list = readList()
    if (index < 0 || index >= list.length) return list
    const next = list.map(function(item, i) {
      if (i !== index) return item
      return { ...item, title: title }
    })
    writeList(next)
    return next
  },
  moveByIndex(index, direction) {
    const list = readList()
    const targetIndex = direction === 'up' ? index - 1 : index + 1
    if (index < 0 || index >= list.length) return list
    if (targetIndex < 0 || targetIndex >= list.length) return list
    const next = list.slice()
    const temp = next[index]
    next[index] = next[targetIndex]
    next[targetIndex] = temp
    writeList(next)
    return next
  },
  remove(fullPath) {
    const list = readList()
    const next = list.filter(item => item.fullPath !== fullPath)
    writeList(next)
    return next
  },
  rename(fullPath, title) {
    const list = readList()
    const next = list.map(item => {
      if (item.fullPath !== fullPath) return item
      return {
        ...item,
        title: title
      }
    })
    writeList(next)
    return next
  },
  move(fullPath, direction) {
    const list = readList()
    const index = list.findIndex(item => item.fullPath === fullPath)
    if (index === -1) return list

    const targetIndex = direction === 'up' ? index - 1 : index + 1
    if (targetIndex < 0 || targetIndex >= list.length) return list

    const next = list.slice()
    const temp = next[index]
    next[index] = next[targetIndex]
    next[targetIndex] = temp

    writeList(next)
    return next
  },
  syncFromServer() {
    return serviceAPI.getUserPreference(PREFERENCE_KEY)
      .then(function(response) {
        var data = response.data
        if (data && data.value) {
          try {
            var serverList = JSON.parse(data.value)
            if (Array.isArray(serverList)) {
              Storage.setValue(getUserKey(), JSON.stringify(serverList))
              return serverList
            }
          } catch (e) {
            // JSON inválido del servidor, mantener localStorage
          }
        }
        return readList()
      })
      .catch(function() {
        return readList()
      })
  }
}

export default shortcuts
